import React from 'react';
import './Pages.css';

const Contact: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Contact Us</h1>
      </div>
      
      <div className="page-content">
        <section className="content-section">
          <h2>Get in Touch</h2>
          <p>
            We're here to help! Whether you have questions about the app, need technical support, 
            or want to share feedback, don't hesitate to reach out.
          </p>
        </section>

        <section className="content-section">
          <h2>Email Support</h2>
          <p>
            <strong>General Inquiries & Support:</strong><br/>
            <a href="mailto:info@dreif-ai.com">info@dreif-ai.com</a>
          </p>
          <p>
            <strong>Press & Media:</strong><br/>
            <a href="mailto:press@dreif-ai.com">press@dreif-ai.com</a>
          </p>
          <p>
            <strong>Business Partnerships:</strong><br/>
            <a href="mailto:partners@dreif-ai.com">partners@dreif-ai.com</a>
          </p>
        </section>

        <section className="content-section">
          <h2>Response Times</h2>
          <p>
            We aim to respond to all inquiries within 24-48 hours during business days. 
            For urgent technical issues, please include "URGENT" in your subject line.
          </p>
        </section>

        <section className="content-section">
          <h2>Social Media</h2>
          <p>Follow us for updates, tips, and inspiration:</p>
          <ul>
            <li>Instagram: @getaiportrait</li>
            <li>Twitter: @getaiportrait</li>
            <li>TikTok: @getaiportrait</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>Company Information</h2>
          <p>
            <strong>DREIF AI GmbH</strong><br/>
            Berlin, Germany<br/>
            Website: <a href="https://dreif-ai.com" target="_blank" rel="noopener noreferrer">dreif-ai.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Contact;